import { createRoot } from 'react-dom/client';
import { StrictMode, useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from 'react-router-dom';

import { AppRoutes } from '@percent/hosted-validation-form/routing/AppRoutes';

import { reportWebVitals } from './reportWebVitals';
import { AppProviders } from './providers/AppProviders';
import { EnvironmentOverlay } from '@percent/shared/environment-overlay';

import './index.css';

import TagManager from 'react-gtm-module';

if (process.env.NX_PUBLIC_USE_SENTRY_LOGGER === 'true') {
  Sentry.init({
    dsn: process.env.NX_PUBLIC_SENTRY_DSN,
    autoSessionTracking: true,
    integrations: [
      Sentry.captureConsoleIntegration({ levels: ['warn'] }),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: 0.33,
    environment: process.env.NX_PUBLIC_REACT_APP_ENV,
    release: process.env.NX_VERCEL_GIT_COMMIT_SHA,
    allowUrls: [/https:\/\/*validation.poweredbypercent.com/, /https:\/\/hosted-validation-form-*-percent.vercel.app/],
  });
}

if (process.env.NX_PUBLIC_USE_TAG_MANAGER === 'true') {
  TagManager.initialize({
    gtmId: process.env.NX_PUBLIC_REACT_APP_GTM_ID!,
  });
}

const container = document.getElementById('root');

const root = createRoot(container!);

root.render(
  <StrictMode>
    <AppProviders>
      <EnvironmentOverlay />
      <AppRoutes />
    </AppProviders>
  </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
